import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { FaWhatsapp, FaEnvelope, FaTiktok, FaYoutube, FaInstagram, FaFacebook } from 'react-icons/fa';
import './ThankYou.css';

const ThankYou = () => {
    const { t } = useTranslation('home');
  return (
    <section className="thank-you-page" role="main" aria-labelledby="thankYouTitle">
      <div className="thank-you-container">
      <h2 id="thankYouTitle" tabIndex={-1}>{t('title')}</h2>

    <p>{t('paragraph1', { ns: 'home' })}</p>
    <p>{t('paragraph2', { ns: 'home' })}</p>



      <div className="contact-info" aria-label={t('contactInfoLabel')}>
        <h3>{t('contactUs')}</h3>
        <ul>
          <li>
            <FaWhatsapp aria-hidden="true" />{' '}
            {t('whatsapp')}: <a href="https://wa.me/254702965315?text=Hello%20Olenini%20Tours%20%26%20Safaris%2C%20I%20came%20across%20your%20website%20and%20would%20love%20to%20explore%20safari%20options%20with%20you.
" target="_blank" rel="noopener noreferrer" aria-label={t('whatsappAriaLabel')}>+254 702 965 315</a>
          </li>
          <li>
            <FaEnvelope aria-hidden="true" />{' '}
            {t('email')}: <a href="mailto:info@oleninisafaris.com" aria-label={t('emailAriaLabel')}>info@oleninisafaris@gmail.com</a>
          </li>
        </ul>
      </div>

      <div className="social-links" aria-label={t('socialLinksLabel')}>
        <h3>{t('followUs')}</h3>
        <ul>
          <li>
            <FaTiktok aria-hidden="true" />{' '}
            <a href="https://www.tiktok.com/@oleninisafaris" target="_blank" rel="noopener noreferrer" aria-label={t('tiktokAriaLabel')}>TikTok</a>
          </li>
          <li>
            <FaYoutube aria-hidden="true" />{' '}
            <a href="https://www.youtube.com/@Oleninisafaris-tours" target="_blank" rel="noopener noreferrer" aria-label={t('youtubeAriaLabel')}>YouTube</a>
          </li>
          <li>
            <FaInstagram aria-hidden="true" />{' '}
            <a href="https://www.instagram.com/olenininisafaris" target="_blank" rel="noopener noreferrer" aria-label={t('instagramAriaLabel')}>Instagram</a>
          </li>
          <li>
            <FaFacebook aria-hidden="true" />{' '}
            <a href="https://www.facebook.com/oleninisafaris" target="_blank" rel="noopener noreferrer" aria-label={t('facebookAriaLabel')}>Facebook</a>
          </li>
        </ul>
      </div>

      <nav className="thank-you-nav" aria-label={t('navAriaLabel')}>
        <Link to="/" className="button primary-button" autoFocus>
          {t('backToHome')}
        </Link>
        <Link to="/contact" className="button secondary-button">
          {t('submitAnother')}
        </Link>
      </nav>
    </div>
    </section>
  );
};

export default ThankYou;
